import { ActionTitle } from "@/components/actionTitle/ActionTitle";
import {
  ScrollContainer,
  WidgetContainer,
} from "@/features/workspace/widgets/Components";
import { type WidgetSize, useAlerts } from "@repo/api";
import { Text } from "@repo/skapa";
import { T } from "@repo/translation";
import { useMemo } from "react";

import { CARD_HEIGHT_NORMAL } from "../constants";
import { Table } from "./Table";
import { isActiveOpportunityAlert } from "./utils";

interface Props {
  title: string;
  size: WidgetSize;
}
export const AlertWidget = ({ title, size }: Props) => {
  const { data: alerts = [], isLoading } = useAlerts();

  const visibleAlerts = useMemo(
    () => alerts.filter(isActiveOpportunityAlert),
    [alerts]
  );

  return (
    <WidgetContainer size={CARD_HEIGHT_NORMAL}>
      <ActionTitle title={`${title} (${visibleAlerts.length})`} />
      {visibleAlerts.length === 0 && !isLoading && (
        <Text>
          <T translationKey="label.no_notifications" />
        </Text>
      )}
      <ScrollContainer>
        <Table isLoading={isLoading} size={size} alerts={visibleAlerts} />
      </ScrollContainer>
    </WidgetContainer>
  );
};
